import { parse, stringify } from 'qs';

const getNextQueryKeysArr = search => {
  const queryKeysArr = search.match(/(\?|&)(.*?)=/g).map(e => e.substring(1, e.length - 1));
  const nextIndex = queryKeysArr.findIndex(q => q.toLowerCase() === 'next');
  return queryKeysArr.slice(nextIndex);
};

export const buildNextUrl = (search = '', fallbackUrl) => {
  const queryParams = parse(search, { ignoreQueryPrefix: true });

  if (!('next' in queryParams)) {
    return fallbackUrl;
  }
  const { next, ...rest } = getNextQueryKeysArr(search).reduce((acc, key) => {
    if (!queryParams[key]) {
      return acc;
    }
    return { ...acc, [key]: queryParams[key] };
  }, {});
  const params = stringify(rest);
  if (!params) return next;
  return `${next}&${params}`;
};
